interface Props {
  className?: string;
  message: string;
  progress: {
    current: number;
    total: number;
  };
  progressText?: string;
}

const ProgressBar = ({ className, message, progress, progressText }: Props) => {
  return (
    <div className={className}>
      <div className='progress-bar__message'>
        <span>{message}</span>
        <span>{progressText || `${progress.current}/${progress.total}`}</span>
      </div>
      <div className='progress-bar progress-bar--full-width'>
        <span style={{ maxWidth: `${(progress.current * 100) / progress.total}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
